import { z } from "zod";

export const LINK_TOKEN_HASH_MAX_LENGTH = 256;

export const linkTokenHashSchema = z.string().min(1).max(LINK_TOKEN_HASH_MAX_LENGTH);
